import { Component, ViewChild, NgZone } from '@angular/core';
import { Platform, AlertController, NavController, MenuController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { LokiDbProvider } from '../providers/loki-db/loki-db';
import * as firebaseApp from 'firebase/app';



import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  @ViewChild('content') _NAV: NavController

  loggedUser: any;

  rootPage: any = 'TabsPage';

  public isDesktop1024: boolean;

  public listaMenu: Array<{ name: string, icon: string, link: any, badge: number }> = [];
  selectedMenu = 1
  chatBotBaseUrl = "/assets/OVSchatbotUI/chatbot.html"
  chatBotIframeUrl:SafeResourceUrl = ""

  constructor(public platform: Platform, statusBar: StatusBar,
    splashScreen: SplashScreen, translate: TranslateService,
    public lokiDB: LokiDbProvider,
    private zone: NgZone,
    public alertCtrl: AlertController,
    private sanitizer: DomSanitizer
  ) {

    translate.setDefaultLang('en');
    translate.use('en');


    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();

      if(this.platform.is('ios')) {
        // let status bar overlay webview
        statusBar.overlaysWebView(false);
        // set status bar to white
        statusBar.backgroundColorByHexString('#ffffff');
      }

      splashScreen.hide();
      //this.lokiDB.pushsetup();

      this.isDesktop1024 = (this.platform.is('core') && this.platform.width() > 1024) ? true : false;

      this.listaMenu = [
        {
          name: 'New Contacts',
          icon: 'ios-people-outline',
          link: 'ContactsPage',
          badge: 0
        },
        {
          name: 'Find',
          icon: 'search',
          link: 'FindPage',
          badge: 0
        },
        {
          name: 'Starred',
          icon: 'ios-star-outline',
          link: 'StarredPage',
          badge: 0
        },
        {
          name: 'My Settings',
          icon: 'ios-settings-outline',
          link: 'SettingsPage',
          badge: 0
        },
      ];

      //SE NON SIAMO NEL DESKTOP MA SU MOBILE, ABBIAMO LA FUNZIONALITA' DELLE NOTIFICHE
      if (!this.platform.is('core'))
        this.listaMenu.push({
          name: 'Notifications',
          icon: 'ios-notifications-outline',
          link: 'NotificationsPage',
          badge: this.lokiDB.unreadNotifications()
        });

      firebaseApp.auth().onAuthStateChanged(user => {
        this.loggedUser = user;
        if (this.isDesktop1024){
          this.lokiDB.getChatBotInfo().then(data=>{            
            zone.run(() => {
              let usericion = (data["ovs_usericon"].indexOf('sz=')>0)?data["ovs_usericon"]+'50':data["ovs_usericon"];
              //let usericion = (<string>data["ovs_usericon"]).replace('sz=','')
              console.log(usericion)
              let tempUrl =  this.chatBotBaseUrl + "?" +
              "name="+ encodeURIComponent(data["ovs_firstname"]) + "&" +
              "lastname=" + encodeURIComponent(data["ovs_lastname"]) + "&" +
              "email=" + encodeURIComponent(data["ovs_email"])+ "&" +
              "language=" + encodeURIComponent(data["ovs_language"])+ "&" +
              "matricola=" + encodeURIComponent(data["ovs_matricola"])+ "&" +
              "usericon=" + encodeURIComponent(usericion);
              console.log(tempUrl)
              this.chatBotIframeUrl = sanitizer.bypassSecurityTrustResourceUrl(tempUrl)
            });

            console.log(this.chatBotIframeUrl)
          });
        }
      });

      //console.log("PAGINA DI AVVIO DEL MENU");

      if (this.isDesktop1024) this.goHome();

    });


  }


  sectionToLoad(page, idx) {
    let link: string = page.link,
      section: string = page.name;
    this.selectedMenu = idx
    this._NAV.setRoot(link, section);
    //this._MENU.close();
  }



  goHome() {
    //this.rootPage = 'WelcomePage'
    let tabIdx = this.lokiDB.getHomePage()
    //console.log("stampo la home : " +  tabIdx);
    if (isNaN(tabIdx)) {
      this.rootPage = 'FindPage'
    } else {
      if (tabIdx == 3) {
        //this._NAV.setRoot('StarredPage')
        this.rootPage = 'StarredPage';
        this.selectedMenu = 2
      } else {
        //this._NAV.setRoot('FindPage')
        this.rootPage = 'FindPage'
        this.selectedMenu = 1
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts